import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import SectionCard from "../../components/SectionCard";
import SectionRow from "../../components/SectionRow";
import { dateTimeFormat, renderDurationAsNumber } from "utils/helpers/date";
import { getPrimaryActiveResource } from "utils/helpers/user";
import { renderSettingsResourceLabel } from "utils/helpers/settings";
import { useCompany } from "utils/hooks/company";

function JobInformation({ user }: any) {
    const { t } = useTranslation();
    const company = useCompany();

    const userJob = useMemo(
        () => getPrimaryActiveResource(user?.jobs || []) as any,
        [user],
    );

    return (
        <SectionCard title={t("job-information")}>
            <SectionRow
                label={t("job-group")}
                value={user?.jobGroup ? renderSettingsResourceLabel(user.jobGroup) : undefined}
            />
            <SectionRow
                label={t("job-code")}
                value={userJob?.code ?? undefined}
            />
            <SectionRow
                label={t("job-title")}
                value={userJob ? renderSettingsResourceLabel(userJob) : undefined}
            />
            <SectionRow
                label={t("date-in-job")}
                value={userJob?.startDate ? dateTimeFormat(userJob.startDate, company?.settings?.dateFormat ?? "") : undefined}
            />
            <SectionRow
                label={t("time-in-job")}
                value={userJob?.startDate ? moment.duration(moment().diff(userJob.startDate)).humanize() : undefined}
            />
            <SectionRow
                label={t("employee-type")}
                value={user?.employeeType ? renderSettingsResourceLabel(user.employeeType) : undefined}
            />
            <SectionRow
                label={t("employment-type")}
                value={user?.employmentType ? renderSettingsResourceLabel(user.employmentType) : undefined}
            />
            <SectionRow
                label={t("user-groups")}
                value={user?.userGroups?.length > 0 ? user.userGroups.map(renderSettingsResourceLabel).join(", ") : undefined}
            />
            <SectionRow
                label={t("groupings")}
                value={user?.groupings?.length > 0 ? user.groupings.map(renderSettingsResourceLabel).join(", ") : undefined}
            />
            <SectionRow
                label={t("union")}
                value={user?.union ? renderSettingsResourceLabel(user.union) : undefined}
            />
            <SectionRow
                label={t("project")}
                value={user?.project ? renderSettingsResourceLabel(user.project) : undefined}
            />
            <SectionRow
                label={t("pay-group")}
                value={user?.payGroup ? renderSettingsResourceLabel(user.payGroup) : undefined}
            />
            <SectionRow
                label={t("pay-frequency")}
                value={user?.payGroup?.frequency ? t(user.payGroup.frequency) : undefined}
            />
            <SectionRow
                label={t("expected-hours")}
                value={user?.expectedHours ? String(renderDurationAsNumber(user.expectedHours)) : undefined}
            />
            <SectionRow
                label={t("expected-working-days")}
                value={user?.expectedWorkingDays?.length > 0 ? user.expectedWorkingDays.map((day: string) => t(day)).join(", ") : undefined}
            />
        </SectionCard>
    );
}

export default JobInformation;
